<div class="loader-wrap flex middle-xs center-xs">
    <div>
        <img src="/assets/images/loader-white.gif" alt="" width="60%">
    </div>
</div>